import { Route } from "react-router";
import { all_routes } from "./all_routes";

import DashboardWebsiteBussiness from "../../../backendComponents/website/dashboardBussiness/dashboardWebsiteBussiness";
import Faq from "../../../backendComponents/website/faq/Faq";
import Feedback from "../../../backendComponents/website/feedback/Feedback";
import ContactUs from "../../../backendComponents/website/contactUs/ContactUs";
import AboutUs from "../../../backendComponents/website/aboutUs/AboutUs";
import TermCondition from "../../../backendComponents/website/termCondition/TermCondition";
import RuningText from "../../../backendComponents/website/runingText/RuningText";
import AppLogo from "../../../backendComponents/website/appLogo/AppLogo";
import Gallary from "../../../backendComponents/website/gallary/Gallary";
import OurTeam from "../../../backendComponents/website/ourTeam/OurTeam";
import ForgetPassword from "../../../backendComponents/website/forgetPassword/ForgetPassword";
import Slider from "../../../backendComponents/website/slider/Slider";
import NewsLetter from "../../../backendComponents/website/newsLetter/NewsLetter";
import Catelogue from "../../../backendComponents/website/catelogue/Catelogue";
import Blog from "../../../backendComponents/website/blog/Blog";
import ColumnApproval from "../../../backendComponents/website/columnApproval/ColumnApproval";
import Cart from "../../../backendComponents/website/cart/Cart";
import ContactRequest from "../../../backendComponents/website/contactRequest/ContactRequest";
import GoogleMap from "../../../backendComponents/website/googleMap/GoogleMap";
import SocialMedia from "../../../backendComponents/website/socialMedia/SocialMedia";
import WebUserRegistration from "../../../backendComponents/website/webUserRegistration/WebUserRegistration";
import BillingAddress from "../../../backendComponents/website/billingAdress/BIllingAddress";
import WishList from "../../../backendComponents/website/wishList/WishList";
import RequestQuotation from "../../../backendComponents/website/requestQuotation/RequestQuotation";
import Offer from "../../../backendComponents/website/offer/Offer";
import ReviewAndRating from "../../../backendComponents/website/reviewAndRating/ReviewAndRating";

const route = all_routes;
export const authWebsiteRoutes = [
  {
    path: route.dashboardWebsite,
    element: <DashboardWebsiteBussiness />,
    route: Route,
    title: "Website Dashboard",
  },
];

export const publicWebsiteRoutes = [
  {
    path: route.faq,
    element: <Faq />,
    route: Route,
    title: "FQA ?",
  },

  {
    path: route.feedback,
    element: <Feedback />,
    route: Route,
    title: "Feedback",
  },

  {
    path: route.contactUs,
    element: <ContactUs />,
    route: Route,
    title: "Contact Us",
  },

  {
    path: route.aboutUs,
    element: <AboutUs />,
    route: Route,
    title: "About Us",
  },

  {
    path: route.termCondition,
    element: <TermCondition />,
    route: Route,
    title: "Term & Condition",
  },

  {
    path: route.runingText,
    element: <RuningText />,
    route: Route,
    title: "Runing Text",
  },

  {
    path: route.appLogo,
    element: <AppLogo />,
    route: Route,
    title: "App Logo",
  },

  {
    path: route.gallary,
    element: <Gallary />,
    route: Route,
    title: "Gallary",
  },

  {
    path: route.team,
    element: <OurTeam />,
    route: Route,
    title: "Our Team",
  },

  {
    path: route.manageVendorRegisterInfo,
    element: <WebUserRegistration />,
    route: Route,
    title: "Vendor Register",
  },

  {
    path: route.forgetPassword,
    element: <ForgetPassword />,
    route: Route,
    title: "Forget Password",
  },

  {
    path: route.bannerSlider,
    element: <Slider />,
    route: Route,
    title: "Slider",
  },
  {
    path: route.newsLetter,
    element: <NewsLetter />,
    route: Route,
    title: "News Letter",
  },
  {
    path: route.catelogue,
    element: <Catelogue />,
    route: Route,
    title: "Catelogue",
  },
  {
    path: route.news,
    element: <Blog />,
    route: Route,
    title: "News Letter",
  },
  {
    path: route.columnApproval,
    element: <ColumnApproval />,
    route: Route,
    title: "Column Approval",
  },

  {
    path: route.cart,
    element: <Cart />,
    route: Route,
    title: "Column Approval",
  },
  {
    path: route.contactRequest,
    element: <ContactRequest />,
    route: Route,
    title: "Contact Request",
  },

  {
    path: route.googleMap,
    element: <GoogleMap />,
    route: Route,
    title: "Google Map",
  },

  {
    path: route.socialMedia,
    element: <SocialMedia />,
    route: Route,
    title: "Social Media",
  },

  {
    path: route.billingShipping,
    element: <BillingAddress />,
    route: Route,
    title: "Billing Address",
  },

  {
    path: route.wishList,
    element: <WishList />,
    route: Route,
    title: "Wish List",
  },

  {
    path: route.orderEnquery,
    element: <RequestQuotation />,
    route: Route,
    title: "Request Quotation",
  },
  {
    path: route.specialOffer,
    element: <Offer />,
    route: Route,
    title: "Offers",
  },

  {
    path: route.rating,
    element: <ReviewAndRating />,
    route: Route,
    title: "Offers",
  },
];
